<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
      @close="beforeClose"
      @submit="confirm"
    class="pushMsgDialog"
  >
    <msg-tpl-form
      ref="outform"

      @submit="submitHandle"
    ></msg-tpl-form>
  </sliderBarDialogShell>
</template>

<script>
import msgTplForm from "@/components/wx/msg-template/msgTplForm";
import {editMsgTpl} from "../../../api/wx/msg-template";

export default {
  name: "editMsgTplDialog",
  components: {
    msgTplForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '模板配置'
    }
  },
  methods: {
    openDialog(){
      this.$emit('open-dialog');
    },
    beforeClose() {
      this.$emit('close');
      this.$refs.outform && this.$refs.outform.selfClear();
    },
    submitHandle(form){
      editMsgTpl(form).then((res) => {
        if(res.code == 200){
          this.$message.success('配置成功')
          this.$emit('edit-success');
        }else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    editSuccess(){
      this.$emit('send-success');
    },
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .pushMsgDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
